import * as THREE from 'three';

export const offlineScene = new THREE.Scene();
offlineScene.name = 'Offline Scene';
